import InventoryListingPlaceholder from './InventoryListingPlaceholder';
export default InventoryListingPlaceholder;